<template>
  <v-dialog v-model="mainDialog" scrollable max-width="430px">
    <v-card color="rgb(20,20,20)">
      <v-toolbar dark flat color="rgb(35,35,35)">
        <v-toolbar-title class="white--text">Thank you for considering subscribing!</v-toolbar-title>
        <v-btn fab small class="ml-auto" color="white">
        <v-icon color="orange accent-4">mdi-patreon</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text
        class="pa-4 white--text"
      >When subscribing, make sure the email address of your Patreon account is the <b class="white--text">same email address as your Trast account</b>!</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="light-green accent-4" text @click.native="close()">Okay</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style></style>

<script>
export default {
  data: () => ({
    mainDialog: false
  }),

  methods: {
    open() {
      this.mainDialog = true;
    },
    close() {
      this.mainDialog = false;
    }
  }
};
</script>
